<div class="search">
  <mat-form-field appearance="outline" class="search-by-input">
    <mat-label>Search By</mat-label>
    <mat-select
      [(ngModel)]="searchByOptionSelected"
      (ngModelChange)="onSearchByChanged($event)"
      id="location-search-by-filter-select"
    >
      @for (option of searchByOptions; track option.value) {
      <mat-option [value]="option.value"> {{ option.label }} </mat-option>}
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="search-input-wrapper">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      #searchInput
      [(ngModel)]="searchString"
      id="search-input"
      class="search-input"
    />
  </mat-form-field>
  <div class="button-group">
    <button mat-flat-button color="primary" class="search-btn" (click)="applySearch(true)">
      <mat-icon>search</mat-icon>
      <span>Search</span>
    </button>

    <button mat-flat-button color="secondary" class="filter-btn" (click)="openFilterPopup()">
      <mat-icon>filter_list</mat-icon>
    </button>
  </div>
</div>

<div class="scroll-x">
  <table class="table custom-table minimized-table" mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="main-header">Name</th>
      <td mat-cell *matCellDef="let row">
        {{ row.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef class="main-header">Type</th>
      <td mat-cell *matCellDef="let row">
        {{ row.type }}
      </td>
    </ng-container>

    <ng-container matColumnDef="directionX">
      <th mat-header-cell *matHeaderCellDef class="main-header">Direction X</th>
      <td mat-cell *matCellDef="let row">
        {{ getDirectionStatus(row, 'x') }}
      </td>
    </ng-container>
    <ng-container matColumnDef="directionY">
      <th mat-header-cell *matHeaderCellDef class="main-header">Direction Y</th>
      <td mat-cell *matCellDef="let row">
        {{ getDirectionStatus(row, 'y') }}
      </td>
    </ng-container>
    <ng-container matColumnDef="directionZ">
      <th mat-header-cell *matHeaderCellDef class="main-header">Direction Z</th>
      <td mat-cell *matCellDef="let row">
        {{ getDirectionStatus(row, 'z') }}
      </td>
    </ng-container>

    <ng-container matColumnDef="view">
      <th mat-header-cell *matHeaderCellDef class="main-header">View</th>
      <td mat-cell *matCellDef="let row">
        <button
          mat-flat-button
          color="secondary"
          (click)="openResultsInNewTab(row)"
        >
          <mat-icon>open_in_new</mat-icon>
          Results
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef class="main-header">Download</th>
      <td mat-cell *matCellDef="let row" class="download-link">
        <button
          mat-flat-button
          color="primary"
          (click)="downloadResult(row)"
          [disabled]="resultsUnavailable(row)"
        >
          <mat-icon>download</mat-icon>
          Download
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef class="main-header">Delete</th>
      <td mat-cell *matCellDef="let row">
        <button
          mat-flat-button
          color="warn"
          (click)="deleteSimulation(row)"
          [disabled]="isDeleteDisabled(row)"
        >
          <mat-icon>delete</mat-icon>
          Delete
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="userEmail">
      <th mat-header-cell *matHeaderCellDef class="main-header">User</th>
      <td mat-cell *matCellDef="let row">
        {{ row.userEmail }}
      </td>
    </ng-container>

    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef class="main-header">Rock file</th>
      <td mat-cell *matCellDef="let row">
        {{ getFileNameWithoutExtension(row.fileName) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef class="main-header">Created At</th>
      <td mat-cell *matCellDef="let row">
        {{ row.createdAt | date : 'dd-MM-yyyy' }}<br />
        {{ row.createdAt | date : 'h:mm a' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="completedAt">
      <th mat-header-cell *matHeaderCellDef class="main-header">Completed At</th>
      <td mat-cell *matCellDef="let row">
        @if (row.completedAt) {
        {{ row.completedAt | date : 'dd-MM-yyyy' }}<br />
        {{ row.completedAt | date : 'h:mm a' }}
        } @else{ — }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="group-row"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row table-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        {{
          !simulations.length
            ? 'No data. Start typing in the search box above'
            : 'No data matching the filter value'
        }}
      </td>
    </tr>
  </table>
</div>

<mat-paginator
  class="mat-paginator"
  [length]="count"
  [pageIndex]="filterData.page! - 1"
  [pageSize]="filterData.pageSize"
  [pageSizeOptions]="[5, 10, 20, 30]"
  aria-label="Select page"
></mat-paginator>
